"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewAssetGod extends new_item_1.default {
    constructor(newAssetGod) {
        super();
        this.lastContacted = newAssetGod.lastContacted;
        if (!newAssetGod.name) {
            throw Error("name required");
        }
        this.name = newAssetGod.name;
        this.siteName = newAssetGod.siteName;
        this.siteId = newAssetGod.siteId;
        this.siteTimezone = newAssetGod.siteTimezone;
        this.impKwh = newAssetGod.impKwh;
        this.parentAsset = newAssetGod.parentAsset;
        this.currentState = newAssetGod.currentState;
        this.userState = newAssetGod.userState;
        this.sku = newAssetGod.sku;
        if (!newAssetGod.code) {
            throw Error("code required");
        }
        this.code = newAssetGod.code;
        this.dataType = newAssetGod.dataType;
        this.generation = newAssetGod.generation;
        this.assetIndex = newAssetGod.assetIndex;
        this.ble = newAssetGod.ble;
        this.boostFinish = newAssetGod.boostFinish;
        this.snoozeFinish = newAssetGod.snoozeFinish;
        this.gatewayId = newAssetGod.gatewayId;
        this.gatewayName = newAssetGod.gatewayName;
        this.applianceType = newAssetGod.applianceType;
        this._permission = newAssetGod._permission;
        this.serialNo = newAssetGod.serialNo;
        this.readOnly = newAssetGod.readOnly;
        this.locked = newAssetGod.locked;
        this.children = newAssetGod.children;
        this.disconnected = newAssetGod.disconnected;
        this.gatewayDisconnected = newAssetGod.gatewayDisconnected;
        this.clampNameTwo = newAssetGod.clampNameTwo;
        this.clampSize = newAssetGod.clampSize;
        this.climaxClamp = newAssetGod.climaxClamp;
        this.triggerRules = newAssetGod.triggerRules;
        this.alertRules = newAssetGod.alertRules;
        this.advancedRules = newAssetGod.advancedRules;
        this.consumption = newAssetGod.consumption;
        this.consumptionPulse = newAssetGod.consumptionPulse;
        this.gasPulse = newAssetGod.gasPulse;
        this.waterPulse = newAssetGod.waterPulse;
        this.waterPulseHot = newAssetGod.waterPulseHot;
        this.temperature = newAssetGod.temperature;
        this.humidity = newAssetGod.humidity;
        this.light = newAssetGod.light;
        this.occupancy = newAssetGod.occupancy;
        this.assetSignalStrength = newAssetGod.assetSignalStrength;
        this.assetBatteryVoltage = newAssetGod.assetBatteryVoltage;
        this.assetBatteryAlarm = newAssetGod.assetBatteryAlarm;
        this.assetBatteryPercent = newAssetGod.assetBatteryPercent;
        this.firmwareTarget = newAssetGod.firmwareTarget;
        this.assetFirmwareVersion = newAssetGod.assetFirmwareVersion;
        this.assetFirmwareProgress = newAssetGod.assetFirmwareProgress;
        this.demandPhaseOne = newAssetGod.demandPhaseOne;
        this.demandPhaseTwo = newAssetGod.demandPhaseTwo;
        this.demandPhaseThree = newAssetGod.demandPhaseThree;
        this.nbIotEcl = newAssetGod.nbIotEcl;
        this.doReconfigure = newAssetGod.doReconfigure;
    }
}
exports.default = NewAssetGod;
//# sourceMappingURL=new-assetGod.js.map